import * as tslib_1 from "tslib";
import { Rectangle } from "./rectangle";
import { Control } from "./control";
import { TextBlock } from "./textBlock";
import { Image } from "./image";
/**
 * Class used to create 2D buttons
 */

var Button =
/** @class */
function (_super) {
  tslib_1.__extends(Button, _super);
  /**
   * Creates a new Button
   * @param name defines the name of the button
   */


  function Button(name) {
    var _this = _super.call(this, name) || this;

    _this.name = name;
    _this.thickness = 1;
    _this.isPointerBlocker = true;
    var alphaStore = null;

    _this.pointerEnterAnimation = function () {
      alphaStore = _this.alpha;
      _this.alpha -= 0.1;
    };

    _this.pointerOutAnimation = function () {
      if (alphaStore !== null) {
        _this.alpha = alphaStore;
      }
    };

    _this.pointerDownAnimation = function () {
      _this.scaleX -= 0.05;
      _this.scaleY -= 0.05;
    };

    _this.pointerUpAnimation = function () {
      _this.scaleX += 0.05;
      _this.scaleY += 0.05;
    };

    return _this;
  }

  Object.defineProperty(Button.prototype, "image", {
    /**
     * Returns the image part of the button (if any)
     */
    get: function get() {
      return this._image;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Button.prototype, "textBlock", {
    /**
     * Returns the image part of the button (if any)
     */
    get: function get() {
      return this._textBlock;
    },
    enumerable: true,
    configurable: true
  });

  Button.prototype._getTypeName = function () {
    return "Button";
  }; // While being a container, the button behaves like a control.

  /** @hidden */


  Button.prototype._processPicking = function (x, y, type, pointerId, buttonIndex) {
    if (!this._isEnabled || !this.isHitTestVisible || !this.isVisible || this.notRenderable) {
      return false;
    }

    if (!_super.prototype.contains.call(this, x, y)) {
      return false;
    }

    this._processObservables(type, x, y, pointerId, buttonIndex);

    return true;
  };
  /** @hidden */


  Button.prototype._onPointerEnter = function (target) {
    if (!_super.prototype._onPointerEnter.call(this, target)) {
      return false;
    }

    if (this.pointerEnterAnimation) {
      this.pointerEnterAnimation();
    }

    return true;
  };
  /** @hidden */


  Button.prototype._onPointerOut = function (target, force) {
    if (force === void 0) {
      force = false;
    }

    if (this.pointerOutAnimation) {
      this.pointerOutAnimation();
    }

    _super.prototype._onPointerOut.call(this, target, force);
  };
  /** @hidden */


  Button.prototype._onPointerDown = function (target, coordinates, pointerId, buttonIndex) {
    if (!_super.prototype._onPointerDown.call(this, target, coordinates, pointerId, buttonIndex)) {
      return false;
    }

    if (this.pointerDownAnimation) {
      this.pointerDownAnimation();
    }

    return true;
  };
  /** @hidden */


  Button.prototype._onPointerUp = function (target, coordinates, pointerId, buttonIndex, notifyClick) {
    if (this.pointerUpAnimation) {
      this.pointerUpAnimation();
    }

    _super.prototype._onPointerUp.call(this, target, coordinates, pointerId, buttonIndex, notifyClick);
  }; // Statics

  /**
   * Creates a new button made with an image and a text
   * @param name defines the name of the button
   * @param text defines the text of the button
   * @param imageUrl defines the url of the image
   * @returns a new Button
   */


  Button.CreateImageButton = function (name, text, imageUrl) {
    var result = new Button(name); // Adding text

    var textBlock = new TextBlock(name + "_button", text);
    textBlock.textWrapping = true;
    textBlock.textHorizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
    textBlock.paddingLeft = "20%";
    result.addControl(textBlock); // Adding image

    var iconImage = new Image(name + "_icon", imageUrl);
    iconImage.width = "20%";
    iconImage.stretch = Image.STRETCH_UNIFORM;
    iconImage.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
    result.addControl(iconImage); // Store

    result._image = iconImage;
    result._textBlock = textBlock;
    return result;
  };
  /**
   * Creates a new button made with an image
   * @param name defines the name of the button
   * @param imageUrl defines the url of the image
   * @returns a new Button
   */


  Button.CreateImageOnlyButton = function (name, imageUrl) {
    var result = new Button(name); // Adding image

    var iconImage = new Image(name + "_icon", imageUrl);
    iconImage.stretch = Image.STRETCH_FILL;
    iconImage.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
    result.addControl(iconImage); // Store

    result._image = iconImage;
    return result;
  };
  /**
   * Creates a new button made with a text
   * @param name defines the name of the button
   * @param text defines the text of the button
   * @returns a new Button
   */


  Button.CreateSimpleButton = function (name, text) {
    var result = new Button(name); // Adding text

    var textBlock = new TextBlock(name + "_button", text);
    textBlock.textWrapping = true;
    textBlock.textHorizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
    result.addControl(textBlock); // Store

    result._textBlock = textBlock;
    return result;
  };
  /**
   * Creates a new button made with an image and a centered text
   * @param name defines the name of the button
   * @param text defines the text of the button
   * @param imageUrl defines the url of the image
   * @returns a new Button
   */


  Button.CreateImageWithCenterTextButton = function (name, text, imageUrl) {
    var result = new Button(name); // Adding image

    var iconImage = new Image(name + "_icon", imageUrl);
    iconImage.stretch = Image.STRETCH_FILL;
    result.addControl(iconImage); // Adding text

    var textBlock = new TextBlock(name + "_button", text);
    textBlock.textWrapping = true;
    textBlock.textHorizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
    result.addControl(textBlock); // Store

    result._image = iconImage;
    result._textBlock = textBlock;
    return result;
  };

  return Button;
}(Rectangle);

export { Button };